﻿import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { fetchYardsApi, createAssignmentApi, fetchAssignmentsByYardApi, updateAssignmentApi, deleteAssignmentApi, createRoundsBulkApi, fetchOnlyVigilantApi, GetRoundsByAssignments, createRoundApi, GetRoundById, deleteRoundApi, updateRoundApi, assignRoundsBulkApi } from '../../services/api';
import { peDate } from '../../util/util';
import { fixHmsFromCell, fixIsoDateFromCell } from '../../helper/dateHelper';
import { Tooltip as BSTooltip } from 'bootstrap';

export default function Asignacion() {
  const { token } = useAuth();
  const [patios, setPatios] = useState([]);
  const [bulkAssignmentId, setBulkAssignmentId] = useState('');

  const [patioId, setPatioId] = useState('');

  // Calendar state
  const [view, setView] = useState('week'); // 'month' | 'week' | 'day' (por defecto semana estilo Teams)
  const [cursor, setCursor] = useState(() => new Date()); // reference date for view
  const [roundsByAssign, setRoundsByAssign] = useState({}); // { assignmentId: [rounds] }
  const [vigilantes, setVigilantes] = useState([]);
  const [showRoundModal, setShowRoundModal] = useState(false);
  const [roundForm, setRoundForm] = useState({ assignmentsId: '', userId: '', date: '', start: '', end: '', state: 1 });
  const [roundViewMode, setRoundViewMode] = useState(false);
  const [roundLoading, setRoundLoading] = useState(false);
  const [roundUserCache, setRoundUserCache] = useState({}); // { roundId: 'Nombre Apellido' | 'Sin vigilante' }

  // Bulk assign by hour (week view)
  const [showHourAssign, setShowHourAssign] = useState(false);
  const [hourToAssign, setHourToAssign] = useState(null); // 0..23
  const [hourAssignUserId, setHourAssignUserId] = useState('');
  const [hourAssignLoading, setHourAssignLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const list = await fetchYardsApi({ token });
        setPatios(list);
      } catch { }
    })();
  }, [token]);

  const startOfWeek = (d) => {
    const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const day = (x.getDay() + 6) % 7; // Monday=0
    x.setDate(x.getDate() - day);
    return x;
  };

  const daysOfMonth = useMemo(() => {
    const year = cursor.getFullYear();
    const month = cursor.getMonth();
    const first = new Date(year, month, 1);
    const last = new Date(year, month + 1, 0);
    const pre = (first.getDay() + 6) % 7; // days from prev month to fill Monday-start grid
    const post = 6 - ((last.getDay() + 6) % 7);
    const total = pre + last.getDate() + post;
    const arr = [];
    const start = new Date(year, month, 1 - pre);
    for (let i = 0; i < total; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      arr.push(d);
    }
    return arr;
  }, [cursor]);

  const weekDays = useMemo(() => {
    const start = startOfWeek(cursor);
    return Array.from({ length: 7 }, (_, i) => {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      return d;
    });
  }, [cursor]);

  // const isSameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  const monthName = cursor.toLocaleString('es-PE', { month: 'long', year: 'numeric' });
  const weekdayShort = ['Lun', 'Mar', 'Miér', 'Jue', 'Vie', 'Sáb', 'Dom'];

  const goPrev = () => {
    const d = new Date(cursor);
    if (view === 'month') d.setMonth(d.getMonth() - 1);
    else if (view === 'week') d.setDate(d.getDate() - 7);
    else d.setDate(d.getDate() - 1);
    setCursor(d);
  };
  const goNext = () => {
    const d = new Date(cursor);
    if (view === 'month') d.setMonth(d.getMonth() + 1);
    else if (view === 'week') d.setDate(d.getDate() + 7);
    else d.setDate(d.getDate() + 1);
    setCursor(d);
  };
  const goToday = () => setCursor(new Date());

  const styles = `
  .cal-grid { display: grid; gap: 6px; }
  .cal-cell { border: 1px solid #e9ecef; border-radius: 6px; min-height: 90px; padding: 6px; }
  .cal-cell.faded { background: #f8f9fa; color: #6c757d; }
  .cal-head { display: grid; grid-template-columns: repeat(7, 1fr); text-align: center; margin-bottom: 6px; color: #6c757d; font-weight: 600; }
  .cal-grid.month { grid-template-columns: repeat(7, 1fr); }
  .cal-grid.week { grid-template-columns: repeat(7, 1fr); }
  .cal-grid.day { grid-template-columns: 1fr; }
  .cal-daynum { font-size: 0.9rem; font-weight: 600; }
  .cal-assign-dot { position: absolute; top: 6px; right: 6px; width: 10px; height: 10px; border-radius: 50%; background: #0dcaf0; }
  .cal-cell.posrel { position: relative; }
  .cal-hour-list { display: grid; grid-template-columns: 60px 1fr; row-gap: 4px; }
  .cal-hour-row { display: contents; }
  .cal-hour-label { text-align: right; padding-right: 8px; color: #6c757d; font-size: 12px; }
  .cal-hour-slot { height: 20px; border: 1px dashed #dee2e6; border-radius: 4px; background: #fff; }
  .cal-hour-slot.assigned { background: rgba(13, 202, 240, 0.4); border-color: #0dcaf0; }
  .cal-week-head { display: grid; grid-template-columns: 60px repeat(7, 1fr); align-items: center; text-align: center; color: #6c757d; font-weight: 600; }
  .cal-week-grid { display: grid; row-gap: 4px; }
  .cal-week-row { display: grid; grid-template-columns: 60px repeat(7, 1fr); align-items: stretch; }
  .cal-week-hour { text-align: right; padding-right: 8px; color: #6c757d; font-size: 12px; }
  .cal-week-hour .hour-left { display: flex; align-items: center; justify-content: flex-end; gap: 6px; }
  .cal-hour-action { border: none; background: transparent; color: #6c757d; cursor: pointer; padding: 0; }
  .cal-hour-action:hover { color: #0d6efd; }
  .cal-week-slot { height: 20px; border: 1px dashed #dee2e6; border-radius: 4px; background: #fff; }
  /* Hover completo por fila (gris suave) */
  .cal-week-row:hover .cal-week-hour { background: rgba(108,117,125,.12); border-radius: 4px; }
  .cal-week-row:hover .cal-week-slot { background-image: linear-gradient(rgba(108,117,125,.08), rgba(108,117,125,.08)); }
  .cal-slot-inner { display: flex; gap: 4px; align-items: center; padding: 1px 3px; height: 100%; }
  .round-badge { width: 20px; height: 20px; min-width: 20px; border-radius: 4px; background: #808080; border: 1px solid #808080; cursor: pointer; }
  `;

  // Horario de Vigilancia (modal de configuracion)
  const [showSchedule, setShowSchedule] = useState(false);
  const [initDatePlanning, setInitDatePlanning] = useState(''); // date (YYYY-MM-DD)
  const [endDatePlanning, setEndDatePlanning] = useState('');   // date (YYYY-MM-DD)
  const [initHourShift, setInitHourShift] = useState('');       // time
  const [endHourShift, setEndHourShift] = useState('');         // time
  const [observation, setObservation] = useState('');
  const [assignments, setAssignments] = useState([]);
  const [editingAssignId, setEditingAssignId] = useState(null);
  const [editingAssignState, setEditingAssignState] = useState(false);
  const [assignmentToDelete, setAssignmentToDelete] = useState(null);
  const [deletingAssignId, setDeletingAssignId] = useState(null);
  const [toasts, setToasts] = useState([]);
  const [reloading, setReloading] = useState(false);
  const [showBulk, setShowBulk] = useState(false);
  const [bulkRows, setBulkRows] = useState([]); // [{ Ronda, FechaInicio, FechaFin, HoraInicio, HoraFin, errors:[], invalid:{} }]
  const [bulkRawRows, setBulkRawRows] = useState([]);
  const [bulkFileName, setBulkFileName] = useState('');
  const [bulkFileKey, setBulkFileKey] = useState(0);
  const [bulkMinInterval, setBulkMinInterval] = useState(10); // minutos
  const pushToast = (type, msg) => { const id = Date.now() + Math.random(); setToasts((p) => [...p, { id, type, msg }]); setTimeout(() => setToasts((p) => p.filter(t => t.id !== id)), 3500); };
  const clearScheduleForm = () => { setInitDatePlanning(''); setEndDatePlanning(''); setInitHourShift(''); setEndHourShift(''); setObservation(''); };
  const createAssignment = async () => {
    if (!patioId) { pushToast('warning', 'Seleccione un patio'); return; }
    if (!initDatePlanning || !endDatePlanning || !initHourShift || !endHourShift) { pushToast('warning', 'Complete todos los campos'); return; }
    // Validaciones: fechas y horas
    const startDate = new Date(`${initDatePlanning}T00:00:00Z`).getTime();
    const endDate = new Date(`${endDatePlanning}T00:00:00Z`).getTime();
    if (startDate > endDate) { pushToast('warning', 'La fecha de inicio no puede ser mayor a la fecha de fin'); return; }
    const toMin = (hhmm) => { const [h, m] = String(hhmm || '').split(':').map(n => parseInt(n, 10)); return (isNaN(h) ? 0 : h) * 60 + (isNaN(m) ? 0 : m); };
    // Permitir rangos que cruzan medianoche. Si fin <= inicio, sumar 24h.
    const sMin = toMin(initHourShift);
    const eMin = toMin(endHourShift);
    const diffMin = eMin >= sMin ? (eMin - sMin) : (eMin - sMin + 24 * 60);
    if (diffMin < 240) { pushToast('warning', 'La diferencia minima entre horas es de 4 horas'); return; }
    try {
      const toMidnight = (d) => `${d}T00:00:00`;
      const dto = {
        yardId: String(patioId),
        initDatePlanning: toMidnight(initDatePlanning),
        endDatePlanning: toMidnight(endDatePlanning),
        initHourShift,
        endHourShift,
        observation,
      };
      const res = await createAssignmentApi({ token, dto });
      const ok = !!(res?.isSuccess || res?.value);
      if (ok) {
        pushToast('success', 'Registro correcto');
        clearScheduleForm();
        // recargar
        try { const list = await fetchAssignmentsByYardApi({ yardId: patioId, token }); setAssignments(list); } catch { }
      }
      else { throw new Error(res?.message || 'No se pudo registrar'); }
    } catch (e) {
      pushToast('danger', e?.message || 'Error al registrar');
    }
  };
  const startEditAssignment = (a) => {
    setEditingAssignId(a.id);
    setEditingAssignState(Boolean(a.state));
    const toDate = (s) => String(s || '').split('T')[0];
    const toTime = (s) => String(s || '').slice(0, 5);
    setObservation(a.observation || '');
    setInitDatePlanning(toDate(a.initDatePlanning));
    setEndDatePlanning(toDate(a.endDatePlanning));
    setInitHourShift(toTime(a.initHourShift));
    setEndHourShift(toTime(a.endHourShift));
  };
  const cancelEditAssignment = () => { setEditingAssignId(null); setEditingAssignState(false); clearScheduleForm(); };
  const updateAssignment = async () => {
    if (!editingAssignId) return;
    if (!patioId) { pushToast('warning', 'Seleccione un patio'); return; }
    if (!initDatePlanning || !endDatePlanning || !initHourShift || !endHourShift) { pushToast('warning', 'Complete todos los campos'); return; }
    const startDate2 = new Date(`${initDatePlanning}T00:00:00Z`).getTime();
    const endDate2 = new Date(`${endDatePlanning}T00:00:00Z`).getTime();
    if (startDate2 > endDate2) { pushToast('warning', 'La fecha de inicio no puede ser mayor a la fecha de fin'); return; }
    const toMin2 = (hhmm) => { const [h, m] = String(hhmm || '').split(':').map(n => parseInt(n, 10)); return (isNaN(h) ? 0 : h) * 60 + (isNaN(m) ? 0 : m); };
    const sMin2 = toMin2(initHourShift);
    const eMin2 = toMin2(endHourShift);
    const diffMin2 = eMin2 >= sMin2 ? (eMin2 - sMin2) : (eMin2 - sMin2 + 24 * 60);
    if (diffMin2 < 240) { pushToast('warning', 'Debe haber un mínimo de 4 horas de diferencia entre las horas.'); return; }
    const toIsoMidnight = (d) => new Date(`${d}T00:00:00Z`).toISOString();
    const dto = {
      yardId: String(patioId),
      initDatePlanning: toIsoMidnight(initDatePlanning),
      endDatePlanning: toIsoMidnight(endDatePlanning),
      initHourShift,
      endHourShift,
      observation,
      state: Boolean(editingAssignState),
    };
    try {
      const res = await updateAssignmentApi({ id: editingAssignId, token, dto });
      const ok = !!(res?.isSuccess || res?.value);
      if (ok) {
        pushToast('success', 'Asignación modificada correctamente');
        cancelEditAssignment();
        try { const list = await fetchAssignmentsByYardApi({ yardId: patioId, token }); setAssignments(list); } catch { }
      } else {
        const msg = res?.error || res?.message || 'No se pudo modificar';
        throw new Error(msg);
      }
    } catch (e) { pushToast('danger', e?.message || 'Error al modificar'); }
  };
  const openDeleteAssignmentModal = (assignment) => {
    if (!assignment?.id) return;
    setAssignmentToDelete(assignment);
  };
  const closeDeleteAssignmentModal = () => {
    if (deletingAssignId) return;
    setAssignmentToDelete(null);
  };
  const deleteAssignment = async () => {
    if (!assignmentToDelete?.id) return;
    const assignment = assignmentToDelete;
    setDeletingAssignId(assignment.id);
    try {
      await deleteAssignmentApi({ id: assignment.id, token });
      if (editingAssignId === assignment.id) {
        cancelEditAssignment();
      }
      pushToast('success', 'Asignacion eliminada');
      let refreshed = false;
      if (patioId) {
        try {
          const list = await fetchAssignmentsByYardApi({ yardId: patioId, token });
          setAssignments(list);
          refreshed = true;
        } catch { }
      }
      if (!refreshed) {
        setAssignments((prev) => prev.filter((item) => item.id !== assignment.id));
      }
    } catch (e) {
      pushToast('danger', e?.message || 'No se pudo eliminar');
    } finally {
      setDeletingAssignId(null);
      setAssignmentToDelete(null);
    }
  };

  // Refresh assignments + rounds for current patio
  const handleRefresh = async () => {
    if (!patioId) { pushToast('warning', 'Seleccione un patio'); return; }
    setReloading(true);
    try {
      const assigns = await fetchAssignmentsByYardApi({ yardId: patioId, token });
      setAssignments(assigns || []);
      // Rebuild rounds map
      const entries = await Promise.all((assigns || []).map(async (a) => {
        try {
          const list = await GetRoundsByAssignments({ id: a.id, token });
          const arr = Array.isArray(list) ? list : (Array.isArray(list?.value) ? list.value : []);
          return [String(a.id), arr];
        } catch { return [String(a.id), []]; }
      }));
      const map = {};
      entries.forEach(([k, v]) => { map[k] = v; });
      setRoundsByAssign(map);
      setRoundUserCache({});
      pushToast('success', 'Actualizado');
    } catch (e) {
      pushToast('danger', e?.message || 'No se pudo actualizar');
    } finally {
      setReloading(false);
    }
  };
  // ----- Bulk helpers (CSV) -----
  const parseCSV = (text) => {
    const lines = text.split(/\r?\n/).filter(l => l.trim().length > 0);
    if (!lines.length) return [];
    const header = lines[0].split(',').map(s => s.trim());
    const idx = {
      Ronda: header.findIndex(h => /ronda/i.test(h)),
      FechaInicio: header.findIndex(h => /fechainicio/i.test(h)),
      FechaFin: header.findIndex(h => /fechafin/i.test(h)),
      HoraInicio: header.findIndex(h => /horainicio/i.test(h)),
      HoraFin: header.findIndex(h => /horafin/i.test(h)),
    };
    const rows = [];
    for (let i = 1; i < lines.length; i++) {
      const cols = lines[i].split(',');
      if (!cols.length) continue;
      rows.push({
        Ronda: (cols[idx.Ronda] || '').trim(),
        FechaInicio: (cols[idx.FechaInicio] || '').trim(),
        FechaFin: (cols[idx.FechaFin] || '').trim(),
        HoraInicio: (cols[idx.HoraInicio] || '').trim(),
        HoraFin: (cols[idx.HoraFin] || '').trim(),
        errors: [],
      });
    }
    return rows;
  };
  const validateBulkRows = (rows, minInterval) => {
    const timeOk = (t) => /^\d{1,2}:\d{2}(?::\d{2})?$/.test(String(t || ''));
    const toMin = (t) => { const [h, m] = String(t || '').split(':').map(n => parseInt(n, 10)); return (isNaN(h) ? 0 : h) * 60 + (isNaN(m) ? 0 : m); };
    return rows.map(r => {
      const errs = [];
      const invalid = { Ronda: false, FechaInicio: false, FechaFin: false, HoraInicio: false, HoraFin: false };
      if (!r.Ronda) { errs.push('Ronda vacia'); invalid.Ronda = true; }
      const fi = new Date(r.FechaInicio);
      const ff = new Date(r.FechaFin);
      if (isNaN(fi.getTime())) { errs.push('FechaInicio invalida'); invalid.FechaInicio = true; }
      if (isNaN(ff.getTime())) { errs.push('FechaFin invalida'); invalid.FechaFin = true; }
      if (!timeOk(r.HoraInicio)) { errs.push('HoraInicio invalida'); invalid.HoraInicio = true; }
      if (!timeOk(r.HoraFin)) { errs.push('HoraFin invalida'); invalid.HoraFin = true; }
      if (!isNaN(fi.getTime()) && !isNaN(ff.getTime()) && fi.getTime() > ff.getTime()) { errs.push('FechaInicio > FechaFin'); invalid.FechaInicio = true; invalid.FechaFin = true; }
      const dm = toMin(r.HoraFin) - toMin(r.HoraInicio);
      if (!(dm > 0)) { errs.push('Hora Fin debe ser mayor que Hora Inicio'); invalid.HoraInicio = true; invalid.HoraFin = true; }
      if (dm < Number(minInterval || 0)) { errs.push("Minimo " + Number(minInterval) + " minutos de diferencia"); invalid.HoraInicio = true; invalid.HoraFin = true; }
      return { ...r, errors: errs, invalid };
    });
  };

  // Valida una sola fila (reutiliza la lógica existente)
  const validateBulkRow = (row, minInterval) => validateBulkRows([row], minInterval)[0];

  // Actualiza una celda editable y revalida SOLO esa fila
  const updateBulkCell = (index, field, value) => {
    setBulkRows((prev) => {
      const rows = Array.isArray(prev) ? [...prev] : [];
      const current = { ...(rows[index] || {}) };
      let v = value;
      // Normaliza valores desde inputs
      if (field === 'HoraInicio' || field === 'HoraFin') {
        // Asegura HH:mm
        v = String(value || '').slice(0, 5);
      }
      current[field] = v;
      rows[index] = validateBulkRow(current, bulkMinInterval);
      return rows;
    });
  };
  // Carga diámica de SheetJS desde CDN para leer Excel
  const ensureXLSXLoaded = () => new Promise((resolve, reject) => {
    if (window.XLSX) return resolve(window.XLSX);
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/xlsx@0.18.5/dist/xlsx.full.min.js';
    s.onload = () => resolve(window.XLSX);
    s.onerror = () => reject(new Error('No se pudo cargar el parser de Excel'));
    document.body.appendChild(s);
  });

  const parseExcel = async (file) => {
    const XLSX = await ensureXLSXLoaded();
    const data = await file.arrayBuffer();
    const wb = XLSX.read(data, { type: 'array' });
    const ws = wb.Sheets[wb.SheetNames[0]];

    // lee CRUDO para evitar ambigüedad de locales
    const table = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true });
    if (!table.length) return [];

    // busca índices por cabecera
    const header = (table[0] || []).map(String);
    const idx = {
      Ronda: header.findIndex(h => /ronda/i.test(h)),
      FechaInicio: header.findIndex(h => /fechainicio/i.test(h)),
      FechaFin: header.findIndex(h => /fechafin/i.test(h)),
      HoraInicio: header.findIndex(h => /horainicio/i.test(h)),
      HoraFin: header.findIndex(h => /horafin/i.test(h)),
    };

    const rows = [];
    for (let i = 1; i < table.length; i++) {
      const row = table[i] || [];
      // normaliza YA a textos "seguros"
      const fi = fixIsoDateFromCell(row[idx.FechaInicio]);
      const ff = fixIsoDateFromCell(row[idx.FechaFin]);
      const hi = fixHmsFromCell(row[idx.HoraInicio]);
      const hf = fixHmsFromCell(row[idx.HoraFin]);

      rows.push({
        Ronda: String(row[idx.Ronda] ?? '').trim(),
        FechaInicio: fi,
        FechaFin: ff,
        HoraInicio: hi,
        HoraFin: hf,
        errors: [],
      });
    }
    return rows;
  };

  const onBulkFile = async (file) => {
    if (!file) return;
    try {
      let rows = [];
      if (/\.(xlsx|xls)$/i.test(file.name)) rows = await parseExcel(file);
      else if (/\.csv$/i.test(file.name)) rows = parseCSV(await file.text()); // si usas CSV, normaliza igual
      else { pushToast('warning', 'Suba Excel/CSV'); return; }

      // ahora rows ya trae fechas y horas en texto ISO
      setBulkRows(validateBulkRows(rows, bulkMinInterval));
    } catch (e) {
      pushToast('danger', e?.message || 'No se pudo leer el archivo');
    }
  };

  // Cargar asignaciones cuando se abre el modal con patio seleccionado
  React.useEffect(() => {
    let active = true;
    (async () => {
      if (!showSchedule || !patioId) return;
      try {
        const list = await fetchAssignmentsByYardApi({ yardId: patioId, token });
        if (!active) return;
        setAssignments(list);
      } catch { if (active) setAssignments([]); }
    })();
    return () => { active = false; };
  }, [showSchedule, patioId, token]);

  // Cargar asignaciones cuando cambia el patio (para pintar en calendario)
  useEffect(() => {
    let active = true;
    (async () => {
      if (!patioId) { setAssignments([]); return; }
      try {
        const list = await fetchAssignmentsByYardApi({ yardId: patioId, token });
        if (!active) return;
        setAssignments(list);
      } catch { if (active) setAssignments([]); }
    })();
    return () => { active = false; };
  }, [patioId, token]);

  // Cargar vigilantes cuando se abre el modal de crear ronda
  useEffect(() => {
    let active = true;
    (async () => {
      if (!showRoundModal) return;
      try {
        const list = await fetchOnlyVigilantApi({ token });
        if (active) setVigilantes(list || []);
      } catch { if (active) setVigilantes([]); }
    })();
    return () => { active = false; };
  }, [showRoundModal, token]);

  // Cargar rondas por asignación cuando cambien las asignaciones
  useEffect(() => {
    let cancel = false;
    (async () => {
      if (!assignments.length) { setRoundsByAssign({}); return; }
      const entries = await Promise.all(assignments.map(async (a) => {
        try {
          const list = await GetRoundsByAssignments({ id: a.id, token });
          return [String(a.id), Array.isArray(list) ? list : (Array.isArray(list?.value) ? list.value : [])];
        } catch { return [String(a.id), []]; }
      }));
      if (cancel) return;
      const map = {};
      entries.forEach(([k, v]) => { map[k] = v; });
      setRoundsByAssign(map);
    })();
    return () => { cancel = true; };
  }, [assignments, token]);

  const dateOnly = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const parseIsoDate = (s) => {
    const [y, m, rest] = String(s || '').split('-');
    if (!y || !m || !rest) return null;
    const dd = rest.split('T')[0];
    const dt = new Date(Number(y), Number(m) - 1, Number(dd));
    return isNaN(dt.getTime()) ? null : dt;
  };
  const inRange = (d, a) => {
    const sd = parseIsoDate(a.initDatePlanning);
    const ed = parseIsoDate(a.endDatePlanning);
    if (!sd || !ed) return false;
    const x = dateOnly(d).getTime();
    return x >= dateOnly(sd).getTime() && x <= dateOnly(ed).getTime();
  };
  const hourNum = (hhmm) => {
    const [h, m] = String(hhmm || '').split(':').map(n => Number(n));
    return isNaN(h) ? 0 : h + (isNaN(m) ? 0 : m / 60);
  };

  // Versión especí­fica: ¿Ésta asignación aplica en (dí­a, hora)?
  const assignedAtHourFor = (d, h, a) => {
    const s = hourNum(a.initHourShift);
    const e = hourNum(a.endHourShift);
    const todayIn = inRange(d, a);
    if (s === e) return false;
    if (s < e) return todayIn && h >= Math.floor(s) && h < Math.ceil(e);
    if (todayIn && h >= Math.floor(s)) return true;
    const y = new Date(d); y.setDate(d.getDate() - 1);
    const prevIn = inRange(y, a);
    // Evitar que el tramo de madrugada "derrame" fuera del rango visual/asignación
    // Si el día actual está después del fin de asignación, no pintar esa cola.
    const ed = parseIsoDate(a.endDatePlanning);
    if (!ed) return prevIn && h < Math.ceil(e);
    const dayOk = dateOnly(d).getTime() <= dateOnly(ed).getTime();
    return dayOk && prevIn && h < Math.ceil(e);
  };

  // Colores picnicos por asignación (HSL distribuido) y deterministas por id
  const colorMap = useMemo(() => {
    const ids = Array.from(new Set(assignments.map(a => String(a.id || '')))).sort();
    const map = new Map();
    ids.forEach((id, idx) => {
      const hue = Math.floor((idx * 137.508) % 360); // Golden angle for distribution
      const border = `hsl(${hue} 70% 40%)`;
      const bg = `hsl(${hue} 70% 40% / 0.35)`; // translucent fill
      map.set(id, { border, bg });
    });
    return map;
  }, [assignments]);
  const getColorForId = (id) => colorMap.get(String(id)) || { border: '#0dcaf0', bg: 'rgba(13,202,240,.35)' };

  // Utilidades para rondas y slots (1 hora)
  const fmtYMD = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const fmtHM = (h) => `${String(h).padStart(2, '0')}:00`;
  const slotRange = (d, h) => {
    const start = new Date(`${fmtYMD(d)}T${fmtHM(h)}:00`);
    const end = new Date(start.getTime() + 60 * 60 * 1000);
    return [start.getTime(), end.getTime()];
  };
  const parseIsoLike = (s) => { const t = new Date(String(s)); const n = t.getTime(); return isNaN(n) ? null : n; };
  const toLocalIso = (dt) => {
    const p = (n) => String(n).padStart(2, '0');
    return `${dt.getFullYear()}-${p(dt.getMonth() + 1)}-${p(dt.getDate())}T${p(dt.getHours())}:${p(dt.getMinutes())}:${p(dt.getSeconds())}`;
  };
  const roundsAtSlot = (d, h) => {
    const [ts, te] = slotRange(d, h);
    const list = [];
    for (const a of assignments) {
      const arr = roundsByAssign[String(a.id)] || [];
      for (const r of arr) {
        const rs = parseIsoLike(r.initDatePlanning || r.InitDatePlanning);
        const re = parseIsoLike(r.endDatePlanning || r.EndDatePlanning);
        if (rs == null || re == null) continue;
        if (rs < te && re > ts) list.push({ ...r, assignmentsId: String(a.id) });
      }
    }
    return list;
  };

  // Click en bloque para crear ronda
  const handleSlotClick = (d, h) => {
    if (!patioId) { pushToast('warning', 'Seleccione un patio'); return; }
    const a = assignments.find(as => assignedAtHourFor(d, h, as)) || assignments[0];
    if (!a) { pushToast('warning', 'No hay asignaciones para este patio'); return; }
    const date = fmtYMD(d);
    const start = fmtHM(h);
    const endHour = (h + 1) % 24;
    const endDateObj = new Date(d);
    if (endHour === 0) endDateObj.setDate(d.getDate() + 1);
    setRoundForm({ assignmentsId: String(a.id), userId: '', date, start, end: `${String(endHour).padStart(2, '0')}:00`, state: 1 });
    setRoundViewMode(false);
    setShowRoundModal(true);
  };

  const saveRound = async () => {
    const { assignmentsId, userId, date, start, end } = roundForm;
    if (!assignmentsId) { pushToast('warning', 'Asignación no definida'); return; }
    if (!userId) { pushToast('warning', 'Seleccione un vigilante'); return; }
    const initDateObj = new Date(`${date}T${start}:00`);
    let endDateObj = new Date(`${date}T${end}:00`);
    const [sh, sm] = start.split(':').map(Number);
    const [eh, em] = end.split(':').map(Number);
    // Si fin <= inicio en el mismo día, asumimos cruce de medianoche (día siguiente)
    if (eh < sh || (eh === sh && em <= sm)) {
      endDateObj.setDate(endDateObj.getDate() + 1);
    }
    const initDatePlanning = toLocalIso(initDateObj);
    const endDatePlanning = toLocalIso(endDateObj);

    const temp = { id: `temp-${Date.now()}`, userId, assignmentsId, initDatePlanning, endDatePlanning };
    setRoundsByAssign((prev) => ({ ...prev, [assignmentsId]: [...(prev[assignmentsId] || []), temp] }));
    try {
      const res = await createRoundApi({ userId, assignmentsId, initDatePlanning, endDatePlanning, token });
      console.log('Intentar crear una ronda');
      console.log(res)
      if (!(res && (res.isSuccess || res.value || res.id || res.Id))) throw new Error(res?.message || 'No se pudo crear');
      try {
        const list = await GetRoundsByAssignments({ id: assignmentsId, token });
        setRoundsByAssign((prev) => ({ ...prev, [assignmentsId]: Array.isArray(list) ? list : (Array.isArray(list?.value) ? list.value : []) }));
      } catch { }
      pushToast('success', 'Ronda creada');
      setShowRoundModal(false);
    } catch (e) {
      // const ex=   JSON.stringify(e)
      console.log(e);
      setRoundsByAssign((prev) => ({ ...prev, [assignmentsId]: (prev[assignmentsId] || []).filter(r => r !== temp) }));
      console.log(temp)
      console.log(roundsByAssign)

      pushToast('danger', e.message || 'Error al crear ronda');
      // pushToast('danger', e.error);
    }
  };

  // Abrir modal de asignación por hora (semana)
  const openHourAssign = (h) => {
    if (!patioId) { pushToast('warning', 'Seleccione un patio'); return; }
    setHourToAssign(Number(h));
    setHourAssignUserId('');
    setShowHourAssign(true);
  };

  // Cargar vigilantes cuando se abre el modal de asignación por hora
  useEffect(() => {
    let active = true;
    (async () => {
      if (!showHourAssign) return;
      try {
        const list = await fetchOnlyVigilantApi({ token });
        if (active) setVigilantes(list || []);
      } catch { if (active) setVigilantes([]); }
    })();
    return () => { active = false; };
  }, [showHourAssign, token]);

  const applyHourAssign = async () => {
    if (!patioId) { pushToast('warning', 'Seleccione un patio'); return; }
    if (hourToAssign == null) { setShowHourAssign(false); return; }
    if (!hourAssignUserId) { pushToast('warning', 'Seleccione un vigilante'); return; }

    // Reunir rondas de la semana visible que caen en esa hora
    const ids = [];
    const seen = new Set();
    const allowed = new Set([1, 5]);
    for (const d of weekDays) {
      const list = roundsAtSlot(d, hourToAssign);
      for (const r of list) {
        const id = String(r.id ?? r.Id ?? '');
        if (!id || seen.has(id)) continue;
        const uid = r.userId ?? r.UserId ?? r.user?.id ?? r.User?.id ?? null;
        const st = Number(r.state ?? r.State ?? 1);
        if (uid == null && allowed.has(st)) { ids.push(id); seen.add(id); }
      }
    }
    if (!ids.length) { pushToast('warning', 'No hay rondas elegibles en esa hora'); setShowHourAssign(false); return; }

    try {
      setHourAssignLoading(true);
      await assignRoundsBulkApi({ userId: hourAssignUserId, roundIds: ids, token });
      // Refrescar rondas por asignación afectada
      const affectedAssigns = new Set();
      for (const d of weekDays) {
        const list = roundsAtSlot(d, hourToAssign);
        list.forEach(r => { const aid = String(r.assignmentsId ?? r.AssignmentsId ?? ''); if (aid) affectedAssigns.add(aid); });
      }
      for (const aid of affectedAssigns) {
        try {
          const list = await GetRoundsByAssignments({ id: aid, token });
          setRoundsByAssign(prev => ({ ...prev, [aid]: Array.isArray(list) ? list : (Array.isArray(list?.value) ? list.value : []) }));
        } catch { }
      }
      pushToast('success', `Asignadas ${ids.length} rondas`);
      setShowHourAssign(false);
    } catch (e) {
      pushToast('danger', e?.message || 'No se pudo asignar');
    } finally { setHourAssignLoading(false); }
  };

  // Ver detalle de ronda existente y cargar en modal (solo lectura por ahora)
  const openRoundDetail = async (round) => {
    const id = round?.id;
    if (!id || String(id).startsWith('temp-')) return;
    setRoundLoading(true);
    try {
      const data = await GetRoundById({ id, token });
      // console.log('[round detail]', data);
      const r = data?.value || data || {};
      const init = new Date(String(r.initDatePlanning || round.initDatePlanning));
      const end = new Date(String(r.endDatePlanning || round.endDatePlanning));
      const p = (n) => String(n).padStart(2, '0');
      const date = `${init.getFullYear()}-${p(init.getMonth() + 1)}-${p(init.getDate())}`;
      const start = `${p(init.getHours())}:${p(init.getMinutes())}`;
      const endStr = `${p(end.getHours())}:${p(end.getMinutes())}`;
      // Asegurar preselección del vigilante: usar r.user?.id si r.userId no viene en la respuesta
      const resolvedUserId = (r && (r.userId ?? (r.user && r.user.id))) ?? (round && round.userId) ?? '';
      setRoundForm({
        id: String(id),
        assignmentsId: String(r.assignmentsId || round.assignmentsId || ''),
        userId: String(resolvedUserId || ''),
        date,
        start,
        end: endStr,
        state: Number(r.state ?? 1)
      });
      setRoundViewMode(true);
      setShowRoundModal(true);
    } catch (e) {
      pushToast('danger', e?.message || 'No se pudo cargar la ronda');
    } finally {
      setRoundLoading(false);
    }
  };

  const deleteRound = async () => {
    const id = roundForm?.id;
    const assignmentsId = String(roundForm?.assignmentsId || '');
    if (!id) return;
    try {
      setRoundsByAssign((prev) => ({ ...prev, [assignmentsId]: (prev[assignmentsId] || []).filter(r => String(r.id) !== String(id)) }));
      await deleteRoundApi({ id, token });
      try {
        const list = await GetRoundsByAssignments({ id: assignmentsId, token });
        setRoundsByAssign((prev) => ({ ...prev, [assignmentsId]: Array.isArray(list) ? list : (Array.isArray(list?.value) ? list.value : []) }));
      } catch { }
      pushToast('success', 'Ronda eliminada');
      setShowRoundModal(false);
      setRoundViewMode(false);
    } catch (e) {
      pushToast('danger', e?.message || 'No se pudo eliminar la ronda');
    }
  };

  // Tooltip helpers
  const getRoundTooltipText = async (roundId) => {
    const id = String(roundId || '');
    if (!id || id.startsWith('temp-')) return 'Sin vigilante';
    const cached = roundUserCache[id];
    if (cached) return cached;
    try {
      const data = await GetRoundById({ id, token });
      const r = data?.value ?? data ?? {};
      const uid = r.userId ?? r.UserId ?? r.user?.id ?? r.User?.id ?? null;

      let text = 'Sin vigilante';
      if (uid != null) {
        const u = r.user ?? r.User ?? null;
        if (u && (u.name || u.lastName || u.userName || u.username)) {
          text = `${u.name ?? u.userName ?? u.username ?? ''} ${u.lastName ?? ''}`.trim() || 'Sin vigilante';
        } else {
          // fallback con lista local (por si el endpoint no trae el objeto user)
          const v = Array.isArray(vigilantes) ? vigilantes.find(x => String(x.id) === String(uid)) : null;
          if (v) text = `${v.nombres || v.name || v.userName || v.username || ''} ${v.apellidos || ''}`.trim() || 'Sin vigilante';
        }
      }

      setRoundUserCache(prev => ({ ...prev, [id]: text }));
      return text;
    } catch {
      return 'Sin vigilante';
    }
  };
  const handleBadgeEnter = async (e, r) => {
    const el = e.currentTarget;
    const Tooltip = BSTooltip;

    const id = String(r.id ?? r.Id ?? '');
    // Crear/obtener con trigger por defecto (hover/focus). Evitar tooltip nativo.
    el.removeAttribute('title');
    const tip = Tooltip.getOrCreateInstance(el, {
      container: 'body',
      placement: 'top',
    });

    // Asegurar placeholder y mostrar
    el.setAttribute('data-bs-title', 'Cargando...');
    try { tip.show(); } catch { }

    // Resolver texto (consulta o cache)
    const text = roundUserCache[id] ?? await getRoundTooltipText(id);

    // Bootstrap >= 5.2 soporta setContent; versiones 5.0/5.1 requieren recrear
    if (typeof tip.setContent === 'function') {
      try { tip.setContent({ '.tooltip-inner': text }); } catch { }
      try { tip.update(); } catch { }
    } else {
      // Actualiza atributo y recrea para que lea el nuevo contenido
      el.setAttribute('data-bs-title', text);
      try { tip.dispose(); } catch { }
      try {
        const newTip = Tooltip.getOrCreateInstance(el, { container: 'body', placement: 'top' });
        try { newTip.show(); } catch { }
      } catch { }
    }
  };

  const updateRound = async () => {
    const { id, assignmentsId, userId, date, start, end, state } = roundForm || {};
    if (!id) return;
    if (!userId) { pushToast('warning', 'Seleccione un vigilante'); return; }
    const initDateObj = new Date(`${date}T${start}:00`);
    let endDateObj = new Date(`${date}T${end}:00`);
    const [sh, sm] = String(start).split(':').map(Number);
    const [eh, em] = String(end).split(':').map(Number);
    if (eh < sh || (eh === sh && em <= sm)) { endDateObj.setDate(endDateObj.getDate() + 1); }
    const initDatePlanning = toLocalIso(initDateObj);
    const endDatePlanning = toLocalIso(endDateObj);
    const s = Number(state) === 4 ? 4 : 1; // sólo 1 o 4
    try {
      await updateRoundApi({ id, userId, initDatePlanning, endDatePlanning, state: (Number(state) === 5 ? 5 : 1), token });
      // reconsultar
      try {
        const list = await GetRoundsByAssignments({ id: assignmentsId, token });
        setRoundsByAssign((prev) => ({ ...prev, [assignmentsId]: Array.isArray(list) ? list : (Array.isArray(list?.value) ? list.value : []) }));
      } catch { }
      pushToast('success', 'Ronda actualizada');
      setShowRoundModal(false);
      setRoundViewMode(false);
    } catch (e) {
      pushToast('danger', e?.message || 'No se pudo actualizar la ronda');
    }
  };
  const processBulk = async () => {
    if (!patioId) { pushToast('warning', 'Seleccione un patio'); return; }
    // if (!bulkAssignmentId) { pushToast('warning', 'Seleccione una asignación'); return; }
    if (!bulkRows.length) { pushToast('warning', 'Cargue un archivo'); return; }
    if (bulkRows.some(r => r.errors?.length)) {
      pushToast('danger', 'Hay filas con errores'); return;
    }

    const rows = bulkRows.map(({ FechaInicio, FechaFin, HoraInicio, HoraFin }) =>
      ({ FechaInicio, FechaFin, HoraInicio, HoraFin }));


    try {
      //console.log('[bulk first row]', rows[0]);

      const res = await createRoundsBulkApi({ yardId: patioId, rows, token });
      // console.table(res?.errores ?? res?.Errores); // ? verás "Fechas inválidas" o "Asignación inexistente", etc.

      if (res?.error) { pushToast('danger', res.error); return; }

      const { intentados = 0, creados = 0, omitidosDuplicado = 0, errores = [] } = res || {};
      pushToast(creados ? 'success' : errores.length ? 'danger' : 'warning',
        `Creados: ${creados}/${intentados}. Omitidos: ${omitidosDuplicado}. Errores: ${errores.length}.`);

      setShowBulk(false);
      setBulkRows([]);
      setBulkAssignmentId('');
      setBulkFileName('');
      setBulkFileKey((k) => k + 1);

      // refrescar la lista (opcional)
      const list = await fetchAssignmentsByYardApi({ yardId: patioId, token });
      setAssignments(list);

    } catch (e) {
      // console.error(e.message || e.Error);
      pushToast('danger', e?.message || 'Error al registrar rondas');
    }
  };



  return (
    <div className="container-fluid">
      <style>{styles}</style>
      <div className="mb-2">
        <h2 className="mb-2 text-center">Asignación</h2>
      </div>

      <div className="gp-toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast align-items-center text-bg-${t.type} show`} role="alert" aria-live="assertive" aria-atomic="true">
            <div className="d-flex">
              <div className="toast-body">{t.msg}</div>
              <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))} />
            </div>
          </div>
        ))}
      </div>

      <div className="mb-3 d-flex align-items-end justify-content-between gap-2 flex-wrap">
        <div style={{ minWidth: 260, width: 360, maxWidth: '100%' }}>
          <label className="form-label">Patio</label>
          <select className="form-select" value={patioId} onChange={(e) => setPatioId(e.target.value)}>
            <option value="">Seleccionar...</option>
            {patios.map((p) => (
              <option key={p.id} value={p.id}>{p.nombre || p.name}</option>
            ))}
          </select>
        </div>
        <div className='d-flex align-items-center gap-4 flex-nowrap'>
          <div className='d-flex align-items-center gap-2'>
            <span style={{ backgroundColor: '#808080', width: 20, height: 20, borderRadius: '50%', display: 'inline-block' }} />
            <span>Pendiente</span>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <span style={{ backgroundColor: '#007bff', width: 20, height: 20, borderRadius: '50%', display: 'inline-block' }} />
            <span>En curso</span>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <span style={{ backgroundColor: '#28A745', width: 20, height: 20, borderRadius: '50%', display: 'inline-block' }} />
            <span>Finalizado</span>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <span style={{ backgroundColor: '#DC3545', width: 20, height: 20, borderRadius: '50%', display: 'inline-block' }} />
            <span>Emergencia</span>
          </div>
          <div className='d-flex align-items-center gap-2'>
            <span style={{ backgroundColor: '#FFC107', width: 20, height: 20, borderRadius: '50%', display: 'inline-block' }} />
            <span>Cancelado</span>
          </div>
        </div>

        <div className="pb-2">
          <div className="d-flex gap-2">
            <button className="btn btn-outline-secondary" title={patioId ? 'Actualizar' : 'Seleccione un patio'} onClick={handleRefresh} disabled={!patioId || reloading} aria-label="Actualizar">
              {reloading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : (<i className="bi bi-arrow-clockwise" />)}
            </button>
            <button className="btn btn-outline-secondary" title={patioId ? 'Configuración' : 'Seleccione un patio'} onClick={() => { if (patioId) setShowSchedule(true); }} disabled={!patioId}>
              <i className="bi bi-gear" />
            </button>
            <button className="btn btn-outline-success" title={patioId ? 'Rondas masivas' : 'Seleccione un patio'} onClick={() => { if (patioId) { setShowBulk(true); setBulkRows([]); setBulkFileName(''); setBulkFileKey((k) => k + 1); } }} disabled={!patioId}>
              <i className="bi bi-file-earmark-spreadsheet" />
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <div className="btn-group" role="group">
              <button className={`btn btn-sm ${view === 'month' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setView('month')}>Mes</button>
              <button className={`btn btn-sm ${view === 'week' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setView('week')}>Semana</button>
              <button className={`btn btn-sm ${view === 'day' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setView('day')}>Día</button>
            </div>
            <div className="d-flex align-items-center gap-2">
              <button className="btn btn-sm btn-outline-secondary" onClick={goPrev}><i className="bi bi-chevron-left" /></button>
              <button className="btn btn-sm btn-outline-secondary" onClick={goToday}>Hoy</button>
              <button className="btn btn-sm btn-outline-secondary" onClick={goNext}><i className="bi bi-chevron-right" /></button>
            </div>
            <div className="fw-semibold text-capitalize">{view === 'month' ? monthName : cursor.toLocaleDateString('es-PE', { dateStyle: 'medium' })}</div>
          </div>

          {view === 'month' && (
            <>
              <div className="cal-head">
                {weekdayShort.map((w) => (<div key={w}>{w}</div>))}
              </div>
              <div className="cal-grid month">
                {daysOfMonth.map((d, i) => {
                  const faded = d.getMonth() !== cursor.getMonth();
                  return (
                    <div key={i} className={`cal-cell posrel ${faded ? 'faded' : ''}`}>
                      <div className="cal-daynum">{d.getDate()}</div>
                      {(() => { const a = assignments.find(x => inRange(d, x)); if (!a) return null; const col = getColorForId(a.id); return <span className="cal-assign-dot" style={{ background: col.border }} />; })()}
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {view === 'week' && (
            <>
              <div className="cal-week-head mb-2">
                <div></div>
                {weekDays.map((d, i) => (<div key={i}>{weekdayShort[i]} {d.getDate()}</div>))}
              </div>
              <div className="cal-week-grid">
                {Array.from({ length: 24 }, (_, h) => (
                  <div className="cal-week-row" key={h}>
                    <div className="cal-week-hour">
                      <div className="hour-left">
                        <span>{String(h).padStart(2, '0')}:00</span>
                        <button type="button" className="cal-hour-action" title="Asignar vigilante a la semana" onClick={() => openHourAssign(h)}>
                          <i className="bi bi-person-plus" />
                        </button>
                      </div>
                    </div>
                    {weekDays.map((d, di) => {
                      // Elegir color por asignación que aplica exactamente en ese dí­a/hora
                      const a = assignments.find(as => assignedAtHourFor(d, h, as));
                      const col = a ? getColorForId(a.id) : null;
                      const style = col ? { background: col.bg, borderColor: col.border } : {};
                      const rds = roundsAtSlot(d, h);
                      return (
                        <div key={di} className={`cal-week-slot ${a ? 'assigned' : ''}`} style={style} onClick={() => handleSlotClick(d, h)}>
                          <div className="cal-slot-inner">
                            {rds.slice(0, 3).map((r, idx) => {
                              const st = Number(r.state);
                              // const isLocked = st === 2 || st === 3 || st === 4; // 2/3/4 solo lectura
                              const style =
                                st === 3
                                  ? { background: '#28A745', borderColor: '#28A745', cursor: 'not-allowed' }
                                  : st === 2
                                    ? { background: '#007bff', borderColor: '#007bff', cursor: 'not-allowed' } // en curso amarillo
                                    : st === 4
                                      ? { background: '#DC3545', borderColor: '#DC3545', cursor: 'not-allowed' } // emergencia sin color
                                      : st === 5
                                        ? { background: '#FFC107', borderColor: '#FFC107', cursor: 'pointer' } // cancelado gris (editable)
                                        : {};
                              return (
                                <div
                                  key={r.id || idx}
                                  className="round-badge rounded-circle"
                                  style={style}
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  data-bs-title={roundUserCache[String(r.id)] || "Cargando..."}
                                  onMouseEnter={(e) => handleBadgeEnter(e, r)}
                                  onClick={(e) => { e.stopPropagation(); openRoundDetail(r); }}
                                />
                              );
                            })}

                          </div>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </>
          )}

          {view === 'day' && (
            <div className="cal-grid day">
              <div className="cal-cell">
                <div className="cal-daynum mb-2">{cursor.toLocaleDateString('es-PE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</div>
                <div className="cal-hour-list">
                  {Array.from({ length: 24 }, (_, h) => (
                    <div className="cal-hour-row" key={h}>
                      <div className="cal-hour-label">{String(h).padStart(2, '0')}:00</div>
                      {(() => {
                        const a = assignments.find(as => assignedAtHourFor(cursor, h, as));
                        const col = a ? getColorForId(a.id) : null;
                        const style = col ? { background: col.bg, borderColor: col.border } : {};
                        const rds = roundsAtSlot(cursor, h);
                        return (
                          <div className={`cal-hour-slot ${a ? 'assigned' : ''}`} style={style} onClick={() => handleSlotClick(cursor, h)}>
                            <div className="cal-slot-inner">
                              {rds.slice(0, 3).map((r, idx) => {
                                const st = Number(r.state);
                                const style =
                                  st === 3
                                    ? { background: '#28A745', borderColor: '#28A745', cursor: 'not-allowed' }
                                    : st === 2
                                      ? { background: '#007bff', borderColor: '#007bff', cursor: 'not-allowed' }
                                      : st === 4
                                        ? { background: '#DC3545', borderColor: '#DC3545', cursor: 'not-allowed' }
                                        : st === 5
                                          ? { background: '#FFC107', borderColor: '#FFC107', cursor: 'pointer' }
                                          : {};
                                return (
                                  <div
                                    key={r.id || idx}
                                    className="round-badge rounded-circle"
                                    style={style}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title={roundUserCache[String(r.id)] || 'Cargando...'}
                                    onMouseEnter={(e) => handleBadgeEnter(e, r)}
                                    onClick={(e) => { e.stopPropagation(); openRoundDetail(r); }}
                                  />
                                );
                              })}
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Modal: Horario de Vigilancia */}
      <div className={`modal fade ${showSchedule ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={showSchedule}>
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <form onSubmit={(e) => { e.preventDefault(); }}>
              <div className="modal-header">
                <h5 className="modal-title">Horario de Vigilancia</h5>
                <button type="button" className="btn-close" onClick={() => setShowSchedule(false)} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row g-2 align-items-end">
                  <div className="col-12">
                    <label className="form-label">Descripción</label>
                    <input className="form-control" placeholder="Observación" value={observation} onChange={(e) => setObservation(e.target.value)} />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label">Fecha de inicio</label>
                    <input type="date" className="form-control" value={initDatePlanning} onChange={(e) => setInitDatePlanning(e.target.value)} />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label">Fecha de fin</label>
                    <input type="date" className="form-control" value={endDatePlanning} onChange={(e) => setEndDatePlanning(e.target.value)} />
                  </div>
                  <div className="col-6">
                    <label className="form-label">Hora inicio</label>
                    <input type="time" className="form-control" value={initHourShift} onChange={(e) => setInitHourShift(e.target.value)} />
                  </div>
                  <div className="col-6">
                    <label className="form-label">Hora fin</label>
                    <input type="time" className="form-control" value={endHourShift} onChange={(e) => setEndHourShift(e.target.value)} />
                  </div>
                  <div className="col-12 d-flex justify-content-end gap-2">
                    {editingAssignId == null ? (
                      <button type="button" className="btn btn-primary" onClick={createAssignment} title="Registrar"><i className="bi bi-plus-lg" /></button>
                    ) : (
                      <>
                        <button type="button" className="btn btn-success" onClick={updateAssignment} title="Guardar cambios"><i className="bi bi-save" /></button>
                        <button type="button" className="btn btn-secondary" onClick={cancelEditAssignment} title="Cancelar ediciÃ³n">Cancelar</button>
                      </>
                    )}
                  </div>
                </div>
                <div className="table-responsive mt-3">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th style={{ width: 140 }}>Acciones</th>
                        <th>Descripción</th>
                        <th>Fecha Inicio</th>
                        <th>Fecha Fin</th>
                        <th>Hora Inicio</th>
                        <th>Hora Fin</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignments.length === 0 && (
                        <tr><td colSpan={6} className="text-center text-muted py-3">Sin asignaciones</td></tr>
                      )}
                      {assignments.map((a, i) => (
                        <tr key={a.id}>
                          <td>{i + 1}</td>
                          <td>
                            <div className="btn-group btn-group-sm">
                              <button className="btn btn-outline-primary" title="Editar" onClick={() => startEditAssignment(a)}><i className="bi bi-pencil" /></button>
                              <button
                                className="btn btn-outline-danger"
                                title="Eliminar"
                                onClick={() => openDeleteAssignmentModal(a)}
                                disabled={deletingAssignId === a.id}
                              >
                                {deletingAssignId === a.id ? (
                                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                  <i className="bi bi-trash" />
                                )}
                              </button>
                            </div>
                          </td>
                          <td>{a.observation}</td>
                          <td>{peDate(a.initDatePlanning)}</td>
                          <td>{peDate(a.endDatePlanning)}</td>
                          <td>{a.initHourShift.slice(0, 5)}</td>
                          <td>{a.endHourShift.slice(0, 5)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowSchedule(false)}>Cerrar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showSchedule && <div className="modal-backdrop fade show" onClick={() => setShowSchedule(false)} />}

      {/* Modal: Confirmar Eliminación */}
      <div className={`modal fade ${assignmentToDelete ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={assignmentToDelete ? 'true' : undefined}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Eliminar asignacion</h5>
              <button type="button" className="btn-close" onClick={closeDeleteAssignmentModal} aria-label="Close" disabled={deletingAssignId === assignmentToDelete?.id}></button>
            </div>
            <div className="modal-body">
              <p className="mb-2">Desea eliminar la asignación seleccionada?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeDeleteAssignmentModal}
                disabled={deletingAssignId === assignmentToDelete?.id}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={deleteAssignment}
                disabled={deletingAssignId === assignmentToDelete?.id}
              >
                {deletingAssignId === assignmentToDelete?.id ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  'Eliminar'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {assignmentToDelete && <div className="modal-backdrop fade show" onClick={closeDeleteAssignmentModal} />}

      {/* Modal: Rondas Masivas */}
      <div className={`modal fade ${showBulk ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={showBulk}>
        <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Rondas masivas</h5>
              <button type="button" className="btn-close" onClick={() => { setShowBulk(false); setBulkRows([]); setBulkFileName(''); setBulkFileKey((k) => k + 1); }} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="mb-2">
                <div className="form-text">Suba un Excel (.xlsx) o CSV con cabeceras: Ronda, FechaInicio, FechaFin, HoraInicio, HoraFin. Formatos: Fecha (YYYY-MM-DD o ISO), Hora (HH:mm o HH:mm:ss). Ningún campo vacío.</div>
                <input key={bulkFileKey} type="file" accept=".xlsx,.xls,.csv" className="form-control" onClick={(e) => { e.target.value = null; }} onChange={(e) => onBulkFile(e.target.files?.[0])} />
              </div>
              <div className="table-responsive" style={{ maxHeight: 260, overflow: 'auto' }}>
                <table className="table table-sm table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>#</th><th>Ronda</th><th>FechaInicio</th><th>FechaFin</th><th>HoraInicio</th><th>HoraFin</th><th>Errores</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bulkRows.length === 0 && <tr><td colSpan={7} className="text-center text-muted py-3">Sin datos</td></tr>}
                    {bulkRows.map((r, idx) => (
                      <tr key={idx} className={r.errors.length ? 'table-danger' : 'table-success'}>
                        <td>{idx + 1}</td>
                        <td>
                          <input
                            className={`form-control form-control-sm ${r.invalid?.Ronda ? 'is-invalid' : ''}`}
                            value={r.Ronda || ''}
                            onChange={(e) => updateBulkCell(idx, 'Ronda', e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            className={`form-control form-control-sm ${r.invalid?.FechaInicio ? 'is-invalid' : ''}`}
                            value={r.FechaInicio || ''}
                            onChange={(e) => updateBulkCell(idx, 'FechaInicio', e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            className={`form-control form-control-sm ${r.invalid?.FechaFin ? 'is-invalid' : ''}`}
                            value={r.FechaFin || ''}
                            onChange={(e) => updateBulkCell(idx, 'FechaFin', e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="time"
                            step="60"
                            className={`form-control form-control-sm ${r.invalid?.HoraInicio ? 'is-invalid' : ''}`}
                            value={(r.HoraInicio || '').slice(0, 5)}
                            onChange={(e) => updateBulkCell(idx, 'HoraInicio', e.target.value)}
                          />
                        </td>
                        <td>
                          <input
                            type="time"
                            step="60"
                            className={`form-control form-control-sm ${r.invalid?.HoraFin ? 'is-invalid' : ''}`}
                            value={(r.HoraFin || '').slice(0, 5)}
                            onChange={(e) => updateBulkCell(idx, 'HoraFin', e.target.value)}
                          />
                        </td>
                        <td style={{ minWidth: 220 }}>{r.errors.join('; ')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <div className="me-auto">
                {bulkRows.length > 0 && (
                  (() => {
                    const errCount = bulkRows.reduce((acc, r) => acc + ((r.errors && r.errors.length) ? 1 : 0), 0);
                    return (
                      <span className={`badge ${errCount > 0 ? 'text-bg-danger' : 'text-bg-success'}`}>
                        {errCount > 0 ? `${errCount} errores` : 'Sin errores'}
                      </span>
                    );
                  })()
                )}
              </div>
              <button type="button" className="btn btn-secondary" onClick={() => { setShowBulk(false); setBulkRows([]); setBulkFileName(''); setBulkFileKey((k) => k + 1); }}>Cerrar</button>
              <button type="button" className="btn btn-primary" onClick={processBulk} disabled={!bulkRows.length || bulkRows.some(r => r.errors && r.errors.length)}>Procesar</button>
            </div>
          </div>
        </div>
      </div>
      {showBulk && <div className="modal-backdrop fade show" onClick={() => { setShowBulk(false); setBulkRows([]); setBulkFileName(''); setBulkFileKey((k) => k + 1); }} />}

      {/* Modal: Asignar vigilante por hora (semana) */}
      <div className={`modal fade ${showHourAssign ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={showHourAssign}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Asignar vigilante – {hourToAssign != null ? String(hourToAssign).padStart(2, '0') + ':00' : ''}</h5>
              <button type="button" className="btn-close" onClick={() => setShowHourAssign(false)} aria-label="Close" disabled={hourAssignLoading}></button>
            </div>
            <div className="modal-body">
              <div className="mb-2 text-muted">Semana: {weekDays[0]?.toLocaleDateString('es-PE')} – {weekDays[6]?.toLocaleDateString('es-PE')}</div>
              <label className="form-label">Vigilante</label>
              <select className="form-select" value={hourAssignUserId} disabled={hourAssignLoading} onChange={(e) => setHourAssignUserId(e.target.value)}>
                <option value="">Seleccionar...</option>
                {vigilantes.map(v => (
                  <option key={v.id} value={v.id}>{(v.nombres || v.name) + ' ' + (v.apellidos || '')}</option>
                ))}
              </select>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowHourAssign(false)} disabled={hourAssignLoading}>Cancelar</button>
              <button type="button" className="btn btn-primary" onClick={applyHourAssign} disabled={hourAssignLoading || !hourAssignUserId}>
                {hourAssignLoading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : 'Asignar'}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showHourAssign && <div className="modal-backdrop fade show" onClick={() => { if (!hourAssignLoading) setShowHourAssign(false); }} />}

      {/* Modal: Crear/Detalle de Ronda */}
      <div className={`modal fade ${showRoundModal ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={showRoundModal}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{roundViewMode ? 'Detalle de Ronda' : 'Crear Ronda'}</h5>
              <button type="button" className="btn-close" onClick={() => setShowRoundModal(false)} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {(() => { /* bandera de solo lectura: cuando viendo detalle y el estado no es editable (solo 1 o 4) */
                return null;
              })()}
              <div className="row g-2">
                {(() => { /* calcular si es solo lectura */ })()}
                {(() => { })()}
                {(() => { })()}
                {(() => { })()}
                {(() => { })()}
                {(() => { })()}
                <div className="col-12">
                  <label className="form-label">Vigilante</label>
                  {(() => {
                    const st = Number(roundForm?.state ?? 1);
                    const isReadOnlyRound = roundViewMode && ![1, 5].includes(st);
                    return (
                      <select className="form-select" value={roundForm.userId}
                        disabled={isReadOnlyRound}
                        onChange={(e) => setRoundForm((p) => ({ ...p, userId: e.target.value }))}>
                        <option value="">Seleccionar...</option>
                        {vigilantes.map(v => (
                          <option key={v.id} value={v.id}>{(v.nombres || v.name) + ' ' + (v.apellidos || '')}</option>
                        ))}
                      </select>
                    );
                  })()}
                </div>
                <div className="col-6">
                  <label className="form-label">Fecha</label>
                  {(() => {
                    const st = Number(roundForm?.state ?? 1);
                    const isReadOnlyRound = roundViewMode && ![1, 5].includes(st);
                    return (
                      <input type="date" className="form-control" value={roundForm.date} disabled={isReadOnlyRound}
                        onChange={(e) => setRoundForm((p) => ({ ...p, date: e.target.value }))} />
                    );
                  })()}
                </div>
                <div className="col-3">
                  <label className="form-label">Hora inicio</label>
                  {(() => {
                    const st = Number(roundForm?.state ?? 1);
                    const isReadOnlyRound = roundViewMode && ![1, 5].includes(st);
                    return (
                      <input type="time" className="form-control" value={roundForm.start} disabled={isReadOnlyRound}
                        onChange={(e) => setRoundForm((p) => ({ ...p, start: e.target.value }))} />
                    );
                  })()}
                </div>
                <div className="col-3">
                  <label className="form-label">Hora fin</label>
                  {(() => {
                    const st = Number(roundForm?.state ?? 1);
                    const isReadOnlyRound = roundViewMode && ![1, 5].includes(st);
                    return (
                      <input type="time" className="form-control" value={roundForm.end} disabled={isReadOnlyRound}
                        onChange={(e) => setRoundForm((p) => ({ ...p, end: e.target.value }))} />
                    );
                  })()}
                </div>
                {roundViewMode && (() => {
                  const st = Number(roundForm?.state ?? 1);
                  const isReadOnlyRound = ![1, 5].includes(st);
                  const stateLabel = (s) => ({ 1: 'Pendiente', 2: 'En curso', 3: 'Finalizado', 4: 'Emergencia', 5: 'Cancelado' }[Number(s)] || '');
                  return (
                    <div className="col-12 col-md-6">
                      <label className="form-label">Estado</label>
                      {isReadOnlyRound ? (
                        <input className="form-control" value={stateLabel(st)} disabled />
                      ) : (
                        <select className="form-select" value={roundForm.state}
                          onChange={(e) => setRoundForm((p) => ({ ...p, state: Number(e.target.value) }))}>
                          <option value={1}>Pendiente</option>
                          <option value={5}>Cancelado</option>
                        </select>
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowRoundModal(false)}>Cancelar</button>
              {roundViewMode ? (
                <>
                  {(() => {
                    const st = Number(roundForm?.state ?? 1);
                    const isReadOnlyRound = ![1, 5].includes(st);
                    return (
                      <>
                        <div className="d-flex gap-5 mx-5">
                          <button type="button" className="btn btn-danger" onClick={deleteRound} disabled={isReadOnlyRound}>Eliminar</button>

                          <button type="button" className="btn btn-primary" onClick={updateRound} disabled={isReadOnlyRound}>Actualizar</button>
                        </div>
                      </>
                    );
                  })()}

                </>
              ) : (
                <button type="button" className="btn btn-primary" onClick={saveRound}>Crear</button>
              )}
            </div>
          </div>
        </div>
      </div>
      {showRoundModal && <div className="modal-backdrop fade show" onClick={() => setShowRoundModal(false)} />}
    </div>
  );
}



